import { render, staticRenderFns } from "./MenuFeedback.vue?vue&type=template&id=3daf060a&scoped=true&"
import script from "./MenuFeedback.vue?vue&type=script&lang=js&"
export * from "./MenuFeedback.vue?vue&type=script&lang=js&"
import style0 from "./MenuFeedback.vue?vue&type=style&index=0&id=3daf060a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf060a",
  null
  
)

export default component.exports